
import { useEffect } from 'react'
import { useAuthStore } from '@/lib/store/auth'
import { AuthService } from '@/lib/services/auth-service'
import { supabase } from '@/integrations/supabase/client'
import { Logger } from '@/lib/utils/logger'

const logger = new Logger('useAuth')

export function useAuth() {
  const { 
    user, 
    session, 
    role, 
    loading, 
    error, 
    initialized,
    signOut,
    clearError,
    refreshAuth,
    checkAuth,
    specialistId,
    caregiverId
  } = useAuthStore()

  // Initialize auth state and set up auth listener
  useEffect(() => {
    let mounted = true;

    const initializeAuth = async () => {
      if (!initialized && mounted) {
        logger.debug('Initializing auth state')
        await checkAuth()
      }
    }

    // Initialize auth state
    initializeAuth()

    // Set up auth state change listener
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        if (mounted) {
          logger.debug('Auth state changed', { event })
          useAuthStore.getState().setAuthData(session)
        }
      }
    )

    // Cleanup subscription and mounted flag
    return () => {
      mounted = false
      subscription.unsubscribe()
    }
  }, [initialized, checkAuth])

  return {
    user,
    session,
    loading,
    role,
    error,
    initialized,
    signIn: AuthService.signIn,
    signOut,
    clearError,
    refreshAuth,
    checkAuth,
    specialistId,
    caregiverId
  }
}
